//
//
//
//
//
//
//
//
//
//
//

export default {
    name: 'ChangelogList',

    props: {
        changelog: {
            type: Array,
            required: true,
        },
    },
}
